import { createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-block col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      "enter-active-class": "animated fadeIn slower delay-2s"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "info-block__semicircle column justify-center items-center" }, [
          _createElementVNode("div", { class: "semicircle__vector" }, [
            _createElementVNode("span", { class: "about__title font-header-2 q-pb-md" }, " ГИС «КОРЕННЫЕ МАЛОЧИСЛЕННЫЕ НАРОДЫ СЕВЕРА» "),
            _createElementVNode("span", { class: "about__text font-text-1" }, "Система предназначена для повышения эффективности деятельности исполнительных органов государственной власти при реализации процессов специализированного учета традиционного хозяйствования, территорий традиционного природопользования, мер государственной поддержки коренным малочисленным народам Севера автономного округа за счет автоматизации процессов формирования и ведения единого цифрового ресурса по объектам учета. ")
          ])
        ], -1)
      ])),
      _: 1
    })
  ]))
}